import classNames from 'classnames'

interface Props {
  theme?: 'alert'
  text: string
  className?: string
}

export default function Alert({ theme = 'alert', text, className }: Props) {
  return (
    <div
      className={classNames('Alert', className, {
        [`Alert--${theme}`]: true,
      })}
    >
      {text}
    </div>
  )
}
